module.exports = __webpack_public_path__ + "static/img/news_28.f9d3dd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_28.png
// module id = PHYH
// module chunks = 2